import getApiHost from './apiHost';
import {
    callFetch,
    API_GET,
    API_DELETE,
    API_POST,
    API_PUT
} from './apiBase';

export function googleLoginApi(googleToken,email){
    let url=`${getApiHost()}/api/worker/v2/googleLogin`;
    let payload = {}
    payload.gmail = email
    return callFetch(API_POST,url,payload,googleToken,'phoenix-google-auth-token');
}

export function getTaskCategoriesApi(jwtToken){
    let url=`${getApiHost()}/api/swarmColony/worker/taskCategories`;
    return callFetch(API_GET,url,null,jwtToken);
}

export function getTasksByCategoryApi(jwtToken,taskCategoryId){
    let url=`${getApiHost()}/api/worker/tasks/v2/${taskCategoryId}`;
    return callFetch(API_GET,url,null,jwtToken);
}

/**Deprecated***/
export function getTasks(jwtToken){
    let url=`${getApiHost()}/api/worker/tasks`;
    return callFetch(API_GET,url,null,jwtToken);
}

export function refreshTasks(jwtToken){
    let url=`${getApiHost()}/api/worker/tasks/refresh`;
    return callFetch(API_GET,url,null,jwtToken);
}

export function acceptTask(jwtToken,paramTaskDistId){
    let payload={};
    payload.taskDistId=paramTaskDistId;
    
    let url=`${getApiHost()}/api/worker/tasks/acccept`;
    return callFetch(API_POST,url,payload,jwtToken);
}

export function getAcceptTaskInfo(jwtToken,paramTaskAcceptId){
    let url=`${getApiHost()}/api/worker/tasks/acccept/${paramTaskAcceptId}`;
    return callFetch(API_GET,url,null,jwtToken);
}

export function getResumeTaskInfo(jwtToken,paramTaskId){
    let url=`${getApiHost()}/api/worker/resume/task/${paramTaskId}`;
    return callFetch(API_GET,url,null,jwtToken);
}

const TWO_FA_AUTH_HEADER='phoenix-google-auth-2fa'
const TWO_FA_AUTH='2FA'

export function postTwofaValidateEmailApi(email){
    let payload={};
    payload.email=email;

    let url=`${getApiHost()}/api/worker/2fa/validateEmail`;
    return callFetch(API_POST,url,payload,TWO_FA_AUTH,TWO_FA_AUTH_HEADER);
}

export function postTwofaLoginWithTacApi(email,loginTac){
    let payload={};
    payload.email=email;
    payload.loginTac=loginTac;

    let url=`${getApiHost()}/api/worker/2fa/loginWithTac`;
    return callFetch(API_POST,url,payload,TWO_FA_AUTH,TWO_FA_AUTH_HEADER);
}

exports.googleLoginApi=googleLoginApi;
exports.getTaskCategoriesApi=getTaskCategoriesApi;
exports.getTasksByCategoryApi=getTasksByCategoryApi;
exports.getTasks=getTasks;
exports.refreshTasks=refreshTasks;
exports.acceptTask=acceptTask;
exports.getAcceptTaskInfo=getAcceptTaskInfo;
exports.getResumeTaskInfo=getResumeTaskInfo;
exports.postTwofaValidateEmailApi=postTwofaValidateEmailApi;
exports.postTwofaLoginWithTacApi=postTwofaLoginWithTacApi;


// WEBPACK FOOTER //
// ./src/apiUtils/api.js